var render = function render(){var _vm=this,_c=_vm._self._c;return (this.ready)?_c('page-edicion',{attrs:{"title":`Módulo ${_vm.modulo.nombre}`}},[_c('formulario-planes-horas',{attrs:{"modulo-plan-horas-normalizados":_vm.horasNormalizadas,"planes":_vm.planes},on:{"submit":_vm.actualizar}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }